const DisableUserTableHead = ({
  isSelectionMode,
  allSelected,
  handleSelectAllUsers,
}) => {
  return (
    <thead className="sticky top-0">
      <tr className="bg-dBlue-100 uppercase tracking-wide rounded-full text-dark-blue">
        {" "}
        {isSelectionMode && (
          <th className="px-4 py-2 rounded-l-full">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAllUsers}
              className="w-4 h-4 accent-input"
            />
          </th>
        )}
        <th className={`px-4 py-2 ${isSelectionMode ? "" : "rounded-l-full"}`}>
          ID
        </th>
        <th className="px-4 py-2">Name</th>
        <th className="px-4 py-2">Email</th>
        <th className="px-4 py-2">Disabled At</th>
        <th className="px-4 py-2">Details</th>
        <th className="px-4 py-2 rounded-r-full">Action</th>
      </tr>
    </thead>
  );
};

export default DisableUserTableHead;
